import React, { memo, useState } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Form } from '@redlink/components/organisms';
import { Space, withPopUp, Text, Divider } from '@redlink/components/atoms';
import { CounterInput } from '@redlink/components/molecules';
import { DataEntryModalTemplate } from '@redlink/components/templates';
import { useLocale } from '@redlink/assets/locale';
import {
  useMutation,
  requestForNewPageQuery,
  getPlanQuery,
  useQuery,
} from '@redlink/services';
import { useValues } from '@redlink/assets/values';
import { useMoneyMask } from '@redlink/core';

export const PurchasePagePage = withPopUp(
  memo(({ onDismiss }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();
    const { staticData } = useValues();
    const { getValue } = useMoneyMask();
    const [count, setCount] = useState(1);

    const { loading, data: { Plan: { price = 0, finalPrice = 0 } = {} } = {} } =
      useQuery(getPlanQuery, {
        variables: { type: staticData.planSubscriptionType.new },
      });

    const [requestForNewPlan, { loading: requestForNewPlanIsBusy }] =
      useMutation(requestForNewPageQuery, {
        done: ({ RequestForNewPage: { paymentUrl } }) =>
          (window.location.href = paymentUrl),
      });

    return (
      <DataEntryModalTemplate>
        <Form
          isBusy={loading || requestForNewPlanIsBusy}
          actions={[
            {
              title: dictionary.cancel,
              variant: 'secondary',
              onPress: onDismiss,
            },
            {
              title: dictionary.pay,
              variant: 'green',
              onPress: () =>
                requestForNewPlan({
                  count,
                }),
            },
          ]}
        >
          <Text style={styles.title}>{dictionary.purchaseNewPage}</Text>
          <Space size={8} />
          <Text style={styles.description}>
            {dictionary.purchaseNewPageDescription}
          </Text>
          <Divider margin={16} />
          <Text style={styles.planTitle}>{dictionary.newCardPlaceHolder}</Text>
          <Space />
          <View style={styles.pricesContainer}>
            <Text style={styles.priceText}>{`${getValue(
              (count * price) / 10
            )} ${dictionary.tomanPostfix}`}</Text>
            <Text style={styles.finalPriceText}>
              {`${getValue((count * finalPrice) / 10)} ${
                dictionary.tomanPostfix
              }`}
            </Text>
            <Text style={styles.subtitleText}>{dictionary.annually2}</Text>
          </View>
          <Space size={50} />
          <CounterInput
            value={count}
            minValue={1}
            onChange={(value) => setCount(value)}
          />
        </Form>
      </DataEntryModalTemplate>
    );
  })
);

const useStyle = createUseStyle(({ colors, size }) => ({
  title: {
    fontSize: 21,
    color: colors.black,
  },
  description: {
    fontSize: 12,
    color: colors.gray21,
  },
  planTitle: {
    fontSize: 27,
    textAlign: 'center',
    color: colors.black,
  },
  priceText: {
    textAlign: 'center',
    fontSize: 18,
    textDecorationLine: 'line-through',
    color: colors.gray21,
  },
  finalPriceText: {
    fontSize: 26,
    textAlign: 'center',
    color: colors.black,
  },
  subtitleText: {
    textAlign: 'center',
    color: colors.black,
    fontSize: 12,
  },
}));
